module.exports = __webpack_public_path__ + "img/vikbet - 에볼루션.9d28c7ed.png";